import React from 'react';

import './servicios.scss';

import CarIcon from '../../../images/home/servicios/car-icon.png';
import HomeIcon from '../../../images/home/servicios/home-icon.png';

import falabellaLogoWhite from 'images/svg/fulcro-white.svg';
import { CheckoutProductType, getCheckoutUrl } from 'helpers/CheckoutUrls';

interface Props {
	id: string;
}

const Servicios: React.FC<Props> = ({ id }) => {
	const handleClick = (productType: CheckoutProductType) => {
		const url = getCheckoutUrl(productType);
		window.location.href = url;
	};

	return (
		<div className="servicios" id={id}>
			<h1 className="title-green ctr">Servicios</h1>
			<div className="servicios__inner">
				<div className="servicios__left ctr-mobile">
					<h1 className="h1">Tenemos planes para ti y para tu compañía</h1>
					<p>
						Ya sea que busques proteger tu hogar o una flota de vehículos, en Connect encontrarás planes personalizados
						que se adaptan perfectamente a tus necesidades. Nuestros servicios están diseñados para brindarte la
						tranquilidad y seguridad que mereces.
						<br />
						<br />
						En Connect, tenemos todo lo que necesitas para estar bien protegido!
					</p>
					<div className="servicios-logo-falabella">
						<img src={falabellaLogoWhite} alt="Logo falabella" />
					</div>
				</div>
				<div className="servicios__right">
					<div
						className="servicios__item auto margin"
						onClick={() => handleClick('autos')}
						style={{ cursor: 'pointer' }}
					>
						<div className="servicios__item__img">
							<img src={CarIcon} alt="Auto" />
						</div>
						<h4>Asistencia para autos</h4>
					</div>
					<div className="servicios__item auto" onClick={() => handleClick('hogar')} style={{ cursor: 'pointer' }}>
						<div className="servicios__item__img">
							<img src={HomeIcon} alt="Hogar" />
						</div>
						<h4>Asistencia en tu hogar</h4>
					</div>
					<a className="servicios__item auto" href={getCheckoutUrl('bundle')}>
						<div className="servicios__item__img bundle">
							<img src={CarIcon} alt="Auto" />
							<img src={HomeIcon} alt="Hogar" />
						</div>
						<h4>Asistencia para auto y hogar</h4>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Servicios;
